import { getConfig } from "../config";

const API_BASE_URL = getConfig().apiUrl;
const GUEST_API = `${API_BASE_URL}/api/v1`;
const QR_SESSION_ERROR_CODES = new Set([
  "QR_SESSION_MISSING",
  "QR_SESSION_INVALID",
  "QR_SESSION_EXPIRED",
]);

const parseApiError = async (response, fallbackMessage) => {
  const payload = await response.json().catch(() => ({}));
  const message = payload.error || fallbackMessage;
  const error = new Error(message);
  error.code = payload.code || null;
  error.status = response.status;
  error.payload = payload;
  return error;
};

export const isQrSessionError = (error) => QR_SESSION_ERROR_CODES.has(error?.code);

export const getRecoveryReason = (error) => {
  switch (error?.code) {
    case "QR_SESSION_EXPIRED":
      return "expired";
    case "QR_SESSION_INVALID":
      return "invalid";
    case "QR_SESSION_MISSING":
      return "missing";
    default:
      return "session_error";
  }
};

export const getQrSessionMessage = (code) => {
  switch (code) {
    case "QR_SESSION_MISSING":
      return "QR oturumu bulunamadı. Lütfen masanızdaki QR kodunu tekrar tarayın.";
    case "QR_SESSION_INVALID":
      return "QR oturumu geçersiz. Lütfen masanızdaki QR kodunu tekrar tarayın.";
    case "QR_SESSION_EXPIRED":
      return "QR oturumunun süresi doldu. Lütfen QR kodunu yeniden tarayın.";
    default:
      return "QR oturumu doğrulanamadı. Lütfen QR kodunu tekrar tarayın.";
  }
};

export const submitOrder = async (token, orderItems, notes) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const response = await fetch(`${GUEST_API}/guest/orders`, {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({
      status: "pending",
      totalPrice: 0,
      paymentStatus: "unpaid",
      notes,
      orderItems,
    }),
  });

  if (!response.ok) {
    throw await parseApiError(response, "Sipariş gönderilemedi.");
  }

  return response.json();
};

export const requestBill = async (token) => {
  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const response = await fetch(`${GUEST_API}/guest/requests`, {
    method: "POST",
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    const error = await parseApiError(response, "Hesap isteği gönderilemedi.");
    if (error.code === "REQUEST_ALREADY_EXISTS") {
      error.message = "Hesap isteği zaten gönderildi.";
    }
    throw error;
  }

  return response.json();
};

export const requestAssistance = async () => {
  const response = await fetch(`${GUEST_API}/guest/assistance-requests`, {
    method: "POST",
    credentials: "include",
  });

  if (!response.ok) {
    const error = await parseApiError(response, "Garson çağrılamadı.");
    if (error.code === "REQUEST_ALREADY_EXISTS") {
      error.message = "Garson zaten haberdar edildi.";
    }
    throw error;
  }

  return response.json();
};

export const fetchMenu = async () => {
  const response = await fetch(`${GUEST_API}/guest/menu`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw await parseApiError(response, "Menü yüklenirken hata oluştu.");
  }

  return response.json();
};

export const fetchOrders = async (token) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const response = await fetch(`${GUEST_API}/guest/orders/existing`, {
    method: "GET",
    headers,
    credentials: "include",
  });

  if (!response.ok) {
    throw await parseApiError(response, "Siparişler yüklenirken hata oluştu.");
  }

  return response.json();
};

export const getApiErrorMessage = (error, defaultMessage = "Bir hata oluştu.") =>
  error?.message || defaultMessage;
